<div class="container">
  <h1 style="text-align: center">Оферта</h1>
  <h3 style="text-align: center">Здесь необходимо разместить текст который составят юристы QazaqPay</h3>
</div>
